import * as React from "react";
import { useEffect, useMemo, useState } from "react";
import { Container, Form, Modal, Spinner } from "react-bootstrap";
import styled from "styled-components";
import AbstractPdfViewer from "./AbstractPdfViewer";

import { pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const GalleryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 2rem 0;

  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.875rem;
  }

  h1 {
    margin-bottom: 0;

    color: #292929;
    font-family: Barlow;
    font-size: 2.5rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;

    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }
  h2 {
    color: #292929;
    font-family: Barlow;
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

    @media (max-width: 768px) {
      color: #292929;
      font-family: Barlow;
      font-size: 1rem;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }
  h3 {
    margin: 0;
    color: #fff;
    font-family: Barlow;
    font-size: 1.0625rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.5rem;

    @media (max-width: 768px) {
      color: #fff;
      font-family: Barlow;
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 700;
      line-height: 1.5rem;
    }
  }
  h4 {
    color: #212529;
    font-family: Barlow;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 600;
    line-height: 1.25rem;

    @media (max-width: 768px) {
      color: #212529;
      font-family: Barlow;
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 600;
      line-height: 1.25rem;
    }
  }
  h5 {
    color: #212529;
    font-family: Barlow;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.25rem;

    @media (max-width: 768px) {
      color: #212529;
      font-family: Barlow;
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 400;
      line-height: 1.25rem;
    }
  }

  .abstract-seasons {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 45px;

    @media (max-width: 768px) {
      gap: 0;
    }
  }
  .season-btns {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }
  .season-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 9px 24px;
    border-radius: 50px;
    border: 1px solid #d1d5db;
    background: #fff;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
    color: #3a3231;
    font-family: Inter;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 600;
    line-height: 1.5rem;
    cursor: pointer;

    &.active {
      background: #9bd4ff;
      border: 1px solid #9bd4ff;
    }
  }

  .abstract-cards-container {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    padding: 34px 0;
    background: #ebebeb;
    width: 100%;
  }
  .abstract-area-of-interests {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
  }
  .area-of-interest {
    display: flex;
    padding: 0px 4px 16px 4px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    border-bottom: 2px solid transparent;

    color: var(--gray-500, #6b7280);
    font-family: Barlow;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.25rem; /* 142.857% */

    @media (max-width: 768px) {
      color: var(--gray-500, #6b7280);
      font-family: Barlow;
      font-size: 0.75rem;
      font-style: normal;
      font-weight: 500;
      line-height: 1.25rem;
    }

    &.active {
      color: #133a57;
      border-bottom: 2px solid #133a57;

      .area-of-interest-count {
        background: #133a57;
        color: #fff;
      }
    }
  }
  .area-of-interest-count {
    display: flex;
    padding: 2px 10px;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    background: #f0f0f0;

    color: var(--gray-800, #1f2937);
    text-align: center;
    font-family: Barlow;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1rem;
  }

  .abstract-cards {
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #e0e0e0;
  }
  .abstract-cards-title {
    padding: 20px 24px;
    background: #133a57;
  }
  .abstract-card {
    display: flex;
    padding: 16px;
    flex-direction: column;
    gap: 8px;
    border-bottom: 1px solid #e0e0e0;
    background-color: #fff;
    cursor: pointer;
    &:hover {
      background-color: #f5f8ff;
    }
  }
  .abstract-title-id {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .abstract-id {
    min-width: 35px;
    padding: 4px 8px;

    border-radius: 6px;
    background: #f3f7ff;

    color: var(--gray-700, #374151);
    font-family: Barlow;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.25rem;
  }
  .abstract-authors {
    display: flex;
    align-items: center;
    gap: 6px;

    span {
      color: #212529;
      font-family: Barlow;
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 400;
      line-height: 1.25rem;
    }
  }

  .abstract-pdf {
    padding: 0;

    iframe {
      width: 100%;
      height: 100dvh;
    }
  }
`;

interface AreaOfInterest {
  key: string;
  name: string;
  count: number;
}

interface Attachment {
  id: number;
  url: string;
  filename: string;
}

interface Coauthor {
  id: number;
  name?: string;
  institution?: string;
}

interface AbstractItem {
  id: number;
  poster_id?: string; // Added poster_id
  title: string;
  area_of_interest: string;
  main_author_name: string;
  presenting_author_name: string;
  season: "normal" | "late_breaking" | string;
  poster?: Attachment;
  coauthors?: Coauthor[];
}

interface AbstractGalleryProps {}

const svgPaper = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M13.125 14.375V17.1875C13.125 17.7053 12.7053 18.125 12.1875 18.125H4.0625C3.54473 18.125 3.125 17.7053 3.125 17.1875V6.5625C3.125 6.04473 3.54473 5.625 4.0625 5.625H5.625C6.05089 5.625 6.46849 5.6605 6.875 5.7287M13.125 14.375H15.9375C16.4553 14.375 16.875 13.9553 16.875 13.4375V9.375C16.875 5.65876 14.1721 2.5738 10.625 1.9787C10.2185 1.9105 9.80089 1.875 9.375 1.875H7.8125C7.29473 1.875 6.875 2.29473 6.875 2.8125V5.7287M13.125 14.375H7.8125C7.29473 14.375 6.875 13.9553 6.875 13.4375V5.7287M16.875 11.25V9.6875C16.875 8.1342 15.6158 6.875 14.0625 6.875H12.8125C12.2947 6.875 11.875 6.45527 11.875 5.9375V4.6875C11.875 3.1342 10.6158 1.875 9.0625 1.875H8.125"
      stroke="#3A3231"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const svgUser = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z"
      fill="#9CA3AF"
    />
    <path
      d="M17 6C17 7.65685 15.6569 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C15.6569 3 17 4.34315 17 6Z"
      fill="#9CA3AF"
    />
    <path
      d="M12.9291 17C12.9758 16.6734 13 16.3395 13 16C13 14.3648 12.4393 12.8606 11.4998 11.6691C12.2352 11.2435 13.0892 11 14 11C16.7614 11 19 13.2386 19 16V17H12.9291Z"
      fill="#9CA3AF"
    />
    <path
      d="M6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11Z"
      fill="#9CA3AF"
    />
  </svg>
);

type SeasonType = "normal" | "late_breaking";

const AbstractGallery: React.FC<AbstractGalleryProps> = () => {
  const [selectedSeason, setSelectedSeason] = useState<SeasonType>("normal");
  const [selectedAreaOfInterest, setSelectedAreaOfInterest] = useState<
    string | null
  >(null);
  const [activeAbstract, setActiveAbstract] = useState<AbstractItem | null>(
    null,
  );
  const [showPdfModal, setShowPdfModal] = useState<boolean>(false);

  const [abstractsData, setAbstractsData] = useState<AbstractItem[]>([]);
  const [areasOfInterest, setAreasOfInterest] = useState<AreaOfInterest[]>([]);
  const [isLoadingAbstracts, setIsLoadingAbstracts] = useState<boolean>(true);
  const [isLoadingAreas, setIsLoadingAreas] = useState<boolean>(true);
  const [searchTerm, setSearchTerm] = useState<string>("");

  useEffect(() => {
    setIsLoadingAreas(true);
    fetch(`/api/abstract_gallery/areas_of_interest?season=${selectedSeason}`)
      .then((res) => res.json())
      .then((data: AreaOfInterest[]) => {
        setAreasOfInterest(data);
        setIsLoadingAreas(false);
        const currentAreaStillExists = data.some(
          (area) => area.key === selectedAreaOfInterest,
        );
        if (
          data.length > 0 &&
          (!selectedAreaOfInterest || !currentAreaStillExists)
        ) {
          setSelectedAreaOfInterest(data[0].key);
        } else if (data.length === 0) {
          setSelectedAreaOfInterest(null);
        }
      })
      .catch((error) => {
        console.error("Error fetching areas of interest:", error);
        setAreasOfInterest([]);
        setSelectedAreaOfInterest(null);
        setIsLoadingAreas(false);
      });
  }, [selectedSeason]);

  useEffect(() => {
    if (isLoadingAreas) {
      return;
    }

    if (
      !(
        (areasOfInterest.length > 0 && selectedAreaOfInterest) ||
        (areasOfInterest.length === 0 && selectedAreaOfInterest === null)
      )
    ) {
      if (!isLoadingAbstracts && abstractsData.length > 0) {
        setAbstractsData([]);
      }
      if (areasOfInterest.length > 0 && !selectedAreaOfInterest) {
        return;
      }
    }

    setIsLoadingAbstracts(true);
    let apiUrl = "/api/abstract_gallery/abstracts?";
    apiUrl += `season=${selectedSeason}&`;

    if (selectedAreaOfInterest) {
      apiUrl += `area_of_interest=${selectedAreaOfInterest}&`;
    }

    apiUrl = apiUrl.replace(/[&?]$/, "");

    fetch(apiUrl)
      .then((res) => res.json())
      .then((data) => {
        setAbstractsData(data);
        setIsLoadingAbstracts(false);
      })
      .catch((error) => {
        console.error("Error fetching abstracts:", error);
        setIsLoadingAbstracts(false);
      });
  }, [selectedSeason, selectedAreaOfInterest, isLoadingAreas, areasOfInterest]);

  const handleSeasonSelect = (season: SeasonType) => {
    setSelectedSeason(season);
  };

  const handleAreaSelect = (area: string | null) => {
    setSelectedAreaOfInterest(area);
  };

  const handleCardClick = (abstractItem: AbstractItem) => {
    if (abstractItem.poster && abstractItem.poster.url) {
      setActiveAbstract(abstractItem);
      setShowPdfModal(true);
    } else {
      console.warn(
        "No poster URL available for this abstract:",
        abstractItem.title,
      );
      alert("No PDF available for this abstract.");
    }
  };

  const handleCloseModal = () => {
    setShowPdfModal(false);
    setActiveAbstract(null);
  };

  const getAuthorDisplay = (item: AbstractItem) => {
    const authors = [item.main_author_name, item.presenting_author_name].filter(
      Boolean,
    );
    // Remove duplicates if first and presenting author are the same and convert Set to Array
    return Array.from(new Set(authors)).join(", ");
  };

  // Split a serial number like "EH02" into its letter prefix and numeric part
  // so abstracts can be ordered by the number within their area-of-interest group.
  const parsePosterId = (posterId?: string) => {
    const match = (posterId || "").match(/^([A-Za-z]*)(\d+)/);
    return {
      prefix: match ? match[1].toUpperCase() : (posterId || "").toUpperCase(),
      number: match ? parseInt(match[2], 10) : Number.MAX_SAFE_INTEGER,
    };
  };

  const sortByPosterId = (a: AbstractItem, b: AbstractItem) => {
    const pa = parsePosterId(a.poster_id);
    const pb = parsePosterId(b.poster_id);
    if (pa.prefix !== pb.prefix) {
      return pa.prefix.localeCompare(pb.prefix);
    }
    if (pa.number !== pb.number) {
      return pa.number - pb.number;
    }
    return a.id - b.id;
  };

  const filteredAbstracts = useMemo(() => {
    const matches = !searchTerm
      ? abstractsData
      : abstractsData.filter(
          (abs) =>
            abs.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            getAuthorDisplay(abs)
              .toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            abs.id.toString().includes(searchTerm) ||
            (abs.poster_id &&
              abs.poster_id.toLowerCase().includes(searchTerm.toLowerCase())),
        );
    return [...matches].sort(sortByPosterId);
  }, [abstractsData, searchTerm]);

  if (isLoadingAreas) {
    return (
      <GalleryWrapper>
        <Container>
          <div className="header-container">
            <h1>E-Posters</h1>
            {/* Search bar placeholder for loading state if needed, or omit */}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </Container>
      </GalleryWrapper>
    );
  }

  return (
    <GalleryWrapper>
      <Container>
        <div className="header-container">
          <h1>E-Posters</h1>

          {/* Season category toggle removed — all submissions are treated as the default (normal) season.
          <div className="abstract-seasons">
            <h4>Select poster category:</h4>
            <div className="season-btns">
              <div
                className={`season-btn ${selectedSeason === 'normal' ? 'active' : ''}`}
                onClick={() => handleSeasonSelect('normal')}
              >
                {svgPaper}
                <span>Free Paper Poster</span>
              </div>
              <div
                className={`season-btn ${selectedSeason === 'late_breaking' ? 'active' : ''}`}
                onClick={() => handleSeasonSelect('late_breaking')}
              >
                {svgPaper}
                <span>Late Breaking E-Poster</span>
              </div>
            </div>
          </div>
          */}

          <Form.Control
            type="text"
            placeholder="Search by topic, author, or ID"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ width: "100%", maxWidth: "300px" }}
          />
        </div>
      </Container>

      <hr style={{ height: "1px", backgroundColor: "#DDD" }} />

      <Container style={{ paddingTop: "1rem" }}>
        <div className="abstract-area-of-interests">
          {areasOfInterest.map((area) => (
            <div
              key={area.key}
              className={`area-of-interest ${selectedAreaOfInterest === area.key ? "active" : ""}`}
              onClick={() => handleAreaSelect(area.key)}
            >
              <span>{area.name}</span>
              <div className="area-of-interest-count">
                {isLoadingAreas ? "..." : area.count}
              </div>
            </div>
          ))}
        </div>
      </Container>
      {/* This div is now controlled by styled-components for flex-grow */}
      <div className="abstract-cards-container">
        {/* The inner Container for cards can remain to manage content padding/margins */}
        <Container className="d-flex flex-column flex-grow-1">
          {isLoadingAbstracts ? (
            <div className="d-flex justify-content-center align-items-center flex-grow-1">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : filteredAbstracts.length > 0 ? (
            <div className="abstract-cards">
              <div className="abstract-cards-title">
                <h3>Posters</h3>
              </div>
              {filteredAbstracts.map((abs) => (
                <div
                  key={abs.id}
                  className="abstract-card"
                  onClick={() => handleCardClick(abs)}
                >
                  <div className="abstract-title-id">
                    <h4 className="abstract-title">{abs.title}</h4>
                    <div className="d-flex gap-2 flex-shrink-0">
                      <div className="abstract-id">{abs.id}</div>
                      {abs.poster_id && (
                        <div className="abstract-id">{abs.poster_id}</div>
                      )}
                    </div>
                  </div>
                  <div className="abstract-authors">
                    {svgUser}
                    <span>{getAuthorDisplay(abs)}</span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p
              style={{
                textAlign: "center",
                color: "#6c757d",
                marginTop: "2rem",
              }}
            >
              No abstracts match the current filter criteria or no abstracts
              available.
            </p>
          )}

          {activeAbstract && activeAbstract.poster && (
            <Modal
              show={showPdfModal}
              onHide={handleCloseModal}
              size="xl"
              centered
            >
              <Modal.Header
                closeButton
                style={{
                  padding: "20px 24px",
                }}
              >
                <Modal.Title>Preview</Modal.Title>
              </Modal.Header>
              <Modal.Body className="abstract-pdf">
                {/* <iframe
                  className="w-100"
                  style={{ height: '80vh' }}
                  src={`${activeAbstract.poster.url}#toolbar=0`}
                  title={`PDF Preview: ${activeAbstract.title}`}
                /> */}
                <AbstractPdfViewer file={activeAbstract.poster.url} />
              </Modal.Body>
            </Modal>
          )}
        </Container>
      </div>
    </GalleryWrapper>
  );
};

export default AbstractGallery;
